import make, { Enum } from '@xaamin/enum';

class TipoComprobante extends Enum {

  name = 'TipoComprobante';

  enum = {
    'Ingreso': 'I',
    'Egreso': 'E',
    'Pago': 'P',
    'Nomina': 'N',
    'Traslado': 'T',
    'Undefined': 'X'
  }

}

export default make(TipoComprobante);